import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { META_CONFIG, MetaConfig, MetaLoader } from './meta.config';
import { MetaGuard } from './meta.guard';

@NgModule({
  providers: [MetaGuard],
})
export class MetaModule {
  static forRoot(loader?: Provider, config?: MetaConfig): ModuleWithProviders<MetaModule> {
    const providers: Provider[] = [MetaGuard];
    if (loader) {
      providers.push(loader);
    }
    if (config) {
      providers.push({ provide: META_CONFIG, useValue: config });
    }
    return {
      ngModule: MetaModule,
      providers,
    };
  }
}

export {
  META_CONFIG,
  MetaConfig,
  MetaLoader,
  MetaSettings,
  MetaStaticLoader,
  PageTitlePositioning,
} from './meta.config';
export { MetaGuard } from './meta.guard';
